import React from 'react';
import Page from '../../layout/Page';
import GiftEmail from './GiftEmail';
import RoleProtected, { userRoles } from '../../RoleProtected';

const GiftEmailPage = () => (
    <RoleProtected roles={userRoles.accountConfiguration}>
        <Page title='Gift Email Details' icon='mobile'>
            <GiftEmail />
        </Page>
    </RoleProtected>
);

export default GiftEmailPage;
